import bannerMob from "../assets/img/banner_475px.png";
import bannerDsk from "../assets/img/banner_1920x450.png";

export const GENERIC_LANDING_CONFIG = {
  firebaseDocId: "evento-aion",
  eventName: "Aion UT",
  introSubtitle:
    "Reservá tu turno para la avant premiere del test drive exclusivo del GAC AION UT y llevate un presente especial.",
  emailEventName: "Aion UT - Test Drive Montironi",
  emailjsTemplateId: process.env.REACT_APP_EMAILJS_TEMPLATE_ID || "",
  banners: {
    mobile: bannerMob,
    desktop: bannerDsk,
  },
};
